// src/hooks/useSubscription.ts
import { useEffect } from 'react';
import { useAuthStore } from '../stores/auth.store';
import { useSubscriptionStore } from '../stores/subscription.store';

export const useSubscription = () => {
  const { user, loading: authLoading } = useAuthStore();
  const { subscription, loading, error, fetchSubscription, upgradeSubscription, addBonusAnalyses, setSubscription, reset } =
    useSubscriptionStore(s => ({
      subscription: s.subscription,
      loading: s.loading,
      error: s.error,
      fetchSubscription: s.fetchSubscription,
      upgradeSubscription: s.upgradeSubscription,
      addBonusAnalyses: s.addBonusAnalyses,
      setSubscription: s.setSubscription,
      reset: s.reset,
    }));

  // Fetch when auth is ready and user exists
  // In useSubscription hook
  useEffect(() => {
    if (!user) {
      // Add a small delay or check to prevent immediate multiple calls
      const timeoutId = setTimeout(() => {
        reset();
      }, 100);
      
      return () => clearTimeout(timeoutId);
    }
  }, [user, reset]);


  return {
    subscription,
    loading: loading || authLoading, // Include authLoading in the loading state
    error,
    refetch: fetchSubscription,
    upgradeSubscription,
    addBonusAnalyses,
    setSubscription,
    reset,
  };
};

